import { z } from "zod";

export const createGroupChatSchema = z.object({
  name: z.string().min(1, "Назва чату обов'язкова"),
  targetUserIds: z.array(z.string()),
});

export type CreateGroupChatFormData = z.infer<typeof createGroupChatSchema>;
